import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventGroupHeader6Pack } from 'src/domains/sportsbook/webview/components/eventsList/eventGroupHeader6Pack/EventGroupHeader6Pack';
import { getMarketNameMLB } from 'src/domains/sportsbook/webview/components/eventsList/eventRowMLB/EventRowMLB.state';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { useCommon } from 'src/domains/common/Common';

interface EventGroupHeaderPropsType {
    dataTest?: string;
    label: string;
    onToggle: () => void;
    open: boolean;
}

export const EventGroupHeaderMLB = observer('EventGroupHeaderMLB', (props: EventGroupHeaderPropsType) => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const { dataTest, label, open, onToggle } = props;

    return (
        <EventGroupHeader6Pack
            dataTest={dataTest}
            label={label}
            marketNames={getMarketNameMLB(languagesState.getTranslation)}
            onToggle={onToggle}
            open={open}
        />
    );
});
